var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlinebookingBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27.8962481px",
    viewBox: "0 0 24 27.8962481",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:cursor-arrow-rays") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Light-New-Icons",
    transform: "translate(-17, -601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:cursor-arrow-rays",
    transform: "translate(13, 599)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.056,28.896 L18.2453333,22.1333333 M18.2453333,22.1333333 L14.8986667,25.1 L15.6573333,12.4733333 L22.6266667,23.0293333 L18.2453333,22.1333333 Z M16,3 L16,6 M23.7786667,6.22133333 L21.6573333,8.34266667 M27,14 L24,14 M10.3426667,19.6573333 L8.22266667,21.7773333 M8,14 L5,14 M10.3426667,8.34266667 L8.22266667,6.22266667",
    id: "Shape",
    stroke: "#192340",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlinebookingBlack);
export default __webpack_public_path__ + "static/media/onlinebooking-black.37a246e722db61d0e761447aaab86b6d.svg";
export { ForwardRef as ReactComponent };